import type { Hit } from "algoliasearch";
import type { Indexable } from "../Indexable.js";
import type { IndexableTable } from "../IndexableTable.js";

export function isHitOfIndexable<T extends IndexableTable>(
	hit: Hit<{ _tags: [IndexableTable] }>,
	table: T,
): hit is Hit<Indexable<T>> {
	return hit._tags[0] === table;
}
